export enum UserRole {
  admin = 'ADMIN',
  staff = 'STAFF',
  bookingAdmin = 'BOOKING_ADMIN',
  bookingUser = 'BOOKING_USER',
  student = 'STUDENT',
  cacheRefresher = 'CACHE_REFRESHER',
}
